import styled from 'styled-components';
import { outlineGray, primaryColor, primaryColorWeak } from '../../config/colors';

export const CatalogItemWrapper = styled.li`
  width: 100%;
  padding: 15px;
  border: 1px solid ${outlineGray};
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  :hover {
    cursor: pointer;
  }
  background-color: ${(props) => (props.isSelected || props.isProject ? primaryColorWeak : 'transparent')};
`;

export const CatalogImageWrapper = styled.div`
  min-width: 50px;
  max-width: 50px;
  height: 45px;
`;

export const CatalogTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  justify-content: start;
  height: 100%;
`;

export const ModuleName = styled.p`
  font-size: 0.813rem;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
`;

export const Project = styled.p`
  max-width: 220px;
  font-size: 0.813rem;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 16px; /* fallback */
  margin-top: 8px;
`;

export const PlusIconContainer = styled.div`
  flex: 1;
  height: 41px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const PlusIcon = styled.label`
  border-radius: 50%;
  transition: background-color 0.3s ease-out;
  color: white;
  font-weight: 700;
  font-size: 1rem;
  user-select: none;
  cursor: pointer;
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${primaryColor};
`;

export const CompareBtn = styled.div`
  font-size: 0.8em;
  color: ${primaryColor};
  cursor: pointer;
`;
